const TermsAndServiceText = () => (
  <p className="text-dashboardalttext text-xs text-center">
    By continuing, you acknowledge that you have read, understood, and agreed to
    our <span className="underline">Terms of Service</span> and{" "}
    <span className="underline">Privacy Policy</span>.
  </p>
)

export default TermsAndServiceText
